// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__na-Tc","name":"styles_name__2bcp9","phone":"styles_phone__WcjCT"};